import Types from './actionTypes';

export const save = (shipperId, data) => ({
  type: Types.SAVE,
  payload: {
    data,
    shipperId,
  },
});

export const saving = () => ({
  type: Types.SAVING,
  payload: {},
});

export const saved = (response) => ({
  type: Types.SAVED,
  payload: {
    response,
  },
});

export const failedToSave = () => ({
  type: Types.FAILED_TO_SAVE,
  payload: {},
});
